import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Target, Clock, Award, CheckCircle2, ArrowRight, Zap, TrendingUp, Heart, Star, Calendar, Trophy } from 'lucide-react';
export function PaceTeams() {
  return <div className="w-full bg-gray-50" data-id="element-1589">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#0E578E] to-[#01AAE7] py-16 sm:py-20 overflow-hidden" data-id="element-1590">
        {/* Animated Background Elements */}
        <div className="absolute inset-0 opacity-10" data-id="element-1591">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" data-id="element-1592"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-1593"></div>
        </div>

        {/* Diagonal Lines Pattern */}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)`
      }} data-id="element-1594"></div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10 text-center" data-id="element-1595">
          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6 leading-tight" data-id="element-1596">
            RaceLookup
            <span className="block mt-2 bg-gradient-to-r from-white via-cyan-100 to-white bg-clip-text text-transparent" data-id="element-1597">
              Pace Teams
            </span>
          </h1>

          {/* Description */}
          <p className="text-lg sm:text-xl text-white/90 leading-relaxed max-w-3xl mx-auto mb-8" data-id="element-1598">
            Join organized pace groups at major races worldwide. Run with
            experienced pacers and fellow runners targeting the same finish
            time.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 max-w-2xl mx-auto" data-id="element-1599">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-1600">
              <div className="text-3xl font-black text-white mb-1" data-id="element-1601">800+</div>
              <div className="text-xs text-white/80 font-semibold" data-id="element-1602">
                Races with Teams
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-1603">
              <div className="text-3xl font-black text-white mb-1" data-id="element-1604">150+</div>
              <div className="text-xs text-white/80 font-semibold" data-id="element-1605">
                Pace Options
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20" data-id="element-1606">
              <div className="text-3xl font-black text-white mb-1" data-id="element-1607">95%</div>
              <div className="text-xs text-white/80 font-semibold" data-id="element-1608">
                Success Rate
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What are Pace Teams Section */}
      <section className="py-16 sm:py-20 bg-white" data-id="element-1609">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1610">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1611">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-1612">
              What are Pace Teams?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-1613">
              Pace Teams are organized groups of runners led by certified pacers
              at major races. Each team targets a specific finish time,
              providing structure, motivation, and camaraderie to help you
              achieve your goal.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-1614">
            <div className="text-center" data-id="element-1615">
              <div className="w-16 h-16 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-2xl flex items-center justify-center mx-auto mb-4" data-id="element-1616">
                <Users className="h-8 w-8 text-white" data-id="element-1617" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1618">
                Run Together
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1619">
                Join a group of runners with the same goal, creating energy and
                accountability throughout the race
              </p>
            </div>

            <div className="text-center" data-id="element-1620">
              <div className="w-16 h-16 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-2xl flex items-center justify-center mx-auto mb-4" data-id="element-1621">
                <Target className="h-8 w-8 text-white" data-id="element-1622" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1623">
                Hit Your Target
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1624">
                Follow experienced pacers who maintain precise splits to help
                you reach your exact time goal
              </p>
            </div>

            <div className="text-center" data-id="element-1625">
              <div className="w-16 h-16 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-2xl flex items-center justify-center mx-auto mb-4" data-id="element-1626">
                <Heart className="h-8 w-8 text-white" data-id="element-1627" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1628">
                Stay Motivated
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1629">
                Benefit from group energy, encouragement, and support when the
                race gets tough
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Available Pace Times Section */}
      <section className="py-16 sm:py-20 bg-gray-50" data-id="element-1630">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1631">
          <div className="text-center mb-12" data-id="element-1632">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-1633">
              Available Pace Times
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1634">
              Find your target pace across popular race distances
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1635">
            {/* Marathon Paces */}
            <div className="bg-white rounded-2xl p-6 border-2 border-gray-100" data-id="element-1636">
              <div className="flex items-center gap-3 mb-4" data-id="element-1637">
                <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center" data-id="element-1638">
                  <Trophy className="h-6 w-6 text-white" data-id="element-1639" />
                </div>
                <h3 className="text-xl font-black text-gray-900" data-id="element-1640">Marathon</h3>
              </div>
              <ul className="space-y-2 text-sm text-gray-600" data-id="element-1641">
                <li className="flex items-center gap-2" data-id="element-1642">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1643" />
                  <span data-id="element-1644">3:00:00 (6:52/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1645">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1646" />
                  <span data-id="element-1647">3:15:00 (7:26/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1648">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1649" />
                  <span data-id="element-1650">3:30:00 (8:00/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1651">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1652" />
                  <span data-id="element-1653">3:45:00 (8:34/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1654">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1655" />
                  <span data-id="element-1656">4:00:00 (9:09/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1657">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1658" />
                  <span data-id="element-1659">4:30:00 (10:18/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1660">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1661" />
                  <span data-id="element-1662">5:00:00 (11:27/mi)</span>
                </li>
              </ul>
            </div>

            {/* Half Marathon Paces */}
            <div className="bg-white rounded-2xl p-6 border-2 border-gray-100" data-id="element-1663">
              <div className="flex items-center gap-3 mb-4" data-id="element-1664">
                <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center" data-id="element-1665">
                  <Trophy className="h-6 w-6 text-white" data-id="element-1666" />
                </div>
                <h3 className="text-xl font-black text-gray-900" data-id="element-1667">
                  Half Marathon
                </h3>
              </div>
              <ul className="space-y-2 text-sm text-gray-600" data-id="element-1668">
                <li className="flex items-center gap-2" data-id="element-1669">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1670" />
                  <span data-id="element-1671">1:30:00 (6:52/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1672">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1673" />
                  <span data-id="element-1674">1:45:00 (8:00/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1675">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1676" />
                  <span data-id="element-1677">2:00:00 (9:09/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1678">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1679" />
                  <span data-id="element-1680">2:15:00 (10:18/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1681">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1682" />
                  <span data-id="element-1683">2:30:00 (11:27/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1684">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1685" />
                  <span data-id="element-1686">2:45:00 (12:35/mi)</span>
                </li>
              </ul>
            </div>

            {/* 10K Paces */}
            <div className="bg-white rounded-2xl p-6 border-2 border-gray-100" data-id="element-1687">
              <div className="flex items-center gap-3 mb-4" data-id="element-1688">
                <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center" data-id="element-1689">
                  <Trophy className="h-6 w-6 text-white" data-id="element-1690" />
                </div>
                <h3 className="text-xl font-black text-gray-900" data-id="element-1691">10K</h3>
              </div>
              <ul className="space-y-2 text-sm text-gray-600" data-id="element-1692">
                <li className="flex items-center gap-2" data-id="element-1693">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1694" />
                  <span data-id="element-1695">40:00 (6:26/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1696">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1697" />
                  <span data-id="element-1698">45:00 (7:15/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1699">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1700" />
                  <span data-id="element-1701">50:00 (8:03/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1702">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1703" />
                  <span data-id="element-1704">55:00 (8:51/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1705">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1706" />
                  <span data-id="element-1707">60:00 (9:39/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1708">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1709" />
                  <span data-id="element-1710">70:00 (11:16/mi)</span>
                </li>
              </ul>
            </div>

            {/* 5K Paces */}
            <div className="bg-white rounded-2xl p-6 border-2 border-gray-100" data-id="element-1711">
              <div className="flex items-center gap-3 mb-4" data-id="element-1712">
                <div className="w-12 h-12 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center" data-id="element-1713">
                  <Trophy className="h-6 w-6 text-white" data-id="element-1714" />
                </div>
                <h3 className="text-xl font-black text-gray-900" data-id="element-1715">5K</h3>
              </div>
              <ul className="space-y-2 text-sm text-gray-600" data-id="element-1716">
                <li className="flex items-center gap-2" data-id="element-1717">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1718" />
                  <span data-id="element-1719">20:00 (6:26/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1720">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1721" />
                  <span data-id="element-1722">22:30 (7:15/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1723">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1724" />
                  <span data-id="element-1725">25:00 (8:03/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1726">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1727" />
                  <span data-id="element-1728">27:30 (8:51/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1729">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1730" />
                  <span data-id="element-1731">30:00 (9:39/mi)</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-1732">
                  <Clock className="h-4 w-4 text-[#01AAE7]" data-id="element-1733" />
                  <span data-id="element-1734">35:00 (11:16/mi)</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 sm:py-20 bg-white" data-id="element-1735">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1736">
          <div className="text-center mb-12" data-id="element-1737">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-1738">
              Why Join a Pace Team?
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-1739">
              Running with a pace team significantly increases your chances of
              achieving your goal time
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1740">
            {/* Benefit 1 */}
            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-100" data-id="element-1741">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1742">
                <Target className="h-7 w-7 text-white" data-id="element-1743" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1744">
                Precise Pacing
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1745">
                Avoid starting too fast or slowing down. Pacers maintain exact
                splits mile by mile to keep you on track.
              </p>
            </div>

            {/* Benefit 2 */}
            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-100" data-id="element-1746">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1747">
                <Users className="h-7 w-7 text-white" data-id="element-1748" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1749">
                Group Energy
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1750">
                Running with others creates momentum and makes the miles pass
                faster, especially during tough moments.
              </p>
            </div>

            {/* Benefit 3 */}
            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-100" data-id="element-1751">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1752">
                <Zap className="h-7 w-7 text-white" data-id="element-1753" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1754">
                Mental Boost
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1755">
                Let the pacer handle the strategy while you focus on running. No
                need to constantly check your watch.
              </p>
            </div>

            {/* Benefit 4 */}
            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-100" data-id="element-1756">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1757">
                <TrendingUp className="h-7 w-7 text-white" data-id="element-1758" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1759">
                Higher Success Rate
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1760">
                Runners with pace teams are 3x more likely to hit their goal
                time compared to running solo.
              </p>
            </div>

            {/* Benefit 5 */}
            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-100" data-id="element-1761">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1762">
                <Heart className="h-7 w-7 text-white" data-id="element-1763" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1764">
                Encouragement
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1765">
                Pacers provide motivation and positive reinforcement throughout
                the race to keep spirits high.
              </p>
            </div>

            {/* Benefit 6 */}
            <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 border-2 border-gray-100" data-id="element-1766">
              <div className="w-14 h-14 bg-gradient-to-br from-[#01AAE7] to-[#0199d6] rounded-xl flex items-center justify-center mb-4" data-id="element-1767">
                <Award className="h-7 w-7 text-white" data-id="element-1768" />
              </div>
              <h3 className="text-xl font-black text-gray-900 mb-3" data-id="element-1769">
                Course Knowledge
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1770">
                Pacers know the course and prepare you for hills, turns, and
                challenging sections ahead.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How to Join Section */}
      <section className="py-16 sm:py-20 bg-gray-50" data-id="element-1771">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1772">
          <div className="text-center mb-12" data-id="element-1773">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-1774">
              How to Join a Pace Team
            </h2>
            <p className="text-lg text-gray-600" data-id="element-1775">
              Finding and joining your pace team is simple
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 sm:p-10 border-2 border-gray-100" data-id="element-1776">
            <ul className="space-y-6" data-id="element-1777">
              <li className="flex items-start gap-4" data-id="element-1778">
                <div className="w-8 h-8 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1 text-white font-black" data-id="element-1779">
                  1
                </div>
                <div data-id="element-1780">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-1781">
                    Search for Your Race
                  </div>
                  <div className="text-gray-600" data-id="element-1782">
                    Browse races on RaceLookup and look for events with "Pace
                    Teams Available" badge
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-4" data-id="element-1783">
                <div className="w-8 h-8 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1 text-white font-black" data-id="element-1784">
                  2
                </div>
                <div data-id="element-1785">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-1786">
                    Select Your Target Time
                  </div>
                  <div className="text-gray-600" data-id="element-1787">
                    Choose the pace team that matches your goal finish time from
                    the available options
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-4" data-id="element-1788">
                <div className="w-8 h-8 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1 text-white font-black" data-id="element-1789">
                  3
                </div>
                <div data-id="element-1790">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-1791">
                    Meet at the Start Line
                  </div>
                  <div className="text-gray-600" data-id="element-1792">
                    Find your pace team's designated meeting area before the
                    race. Pacers will be holding signs with the target time
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-4" data-id="element-1793">
                <div className="w-8 h-8 bg-[#01AAE7] rounded-full flex items-center justify-center flex-shrink-0 mt-1 text-white font-black" data-id="element-1794">
                  4
                </div>
                <div data-id="element-1795">
                  <div className="font-bold text-gray-900 mb-1 text-lg" data-id="element-1796">
                    Run Together
                  </div>
                  <div className="text-gray-600" data-id="element-1797">
                    Stay with your pacer and group throughout the race. Trust
                    the process and enjoy the journey to your goal!
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 sm:py-20 bg-gradient-to-br from-[#0E578E] to-[#01AAE7] relative overflow-hidden" data-id="element-1798">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10" data-id="element-1799">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-1800"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-1801"></div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10 text-center" data-id="element-1802">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-6" data-id="element-1803">
            Ready to Achieve Your Goal?
          </h2>
          <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-1804">
            Find races with pace teams and start your journey to a new personal
            record
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1805">
            <Link to="/events" className="group inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#0E578E] font-bold rounded-xl hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-0.5 text-base" data-id="element-1806">
              <span data-id="element-1807">Browse Races with Pace Teams</span>
              <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-1808" />
            </Link>

            <Link to="/pacer-program" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white font-bold rounded-xl hover:bg-white/20 transition-all text-base" data-id="element-1809">
              Become a Pacer
            </Link>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 sm:py-20 bg-white" data-id="element-1810">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10" data-id="element-1811">
          <div className="text-center mb-12" data-id="element-1812">
            <h2 className="text-3xl sm:text-4xl font-black text-gray-900 mb-4" data-id="element-1813">
              Frequently Asked Questions
            </h2>
          </div>

          <div className="space-y-6" data-id="element-1814">
            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1815">
              <h3 className="text-lg font-black text-gray-900 mb-2" data-id="element-1816">
                Do I need to register separately for a pace team?
              </h3>
              <p className="text-gray-600" data-id="element-1817">
                No! Pace teams are free to join for all registered runners.
                Simply show up at the designated meeting area before the race
                starts.
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1818">
              <h3 className="text-lg font-black text-gray-900 mb-2" data-id="element-1819">
                What if I can't keep up with the pace team?
              </h3>
              <p className="text-gray-600" data-id="element-1820">
                That's perfectly fine! You can drop back at any time. It's
                better to start conservatively and finish strong than to burn
                out early.
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1821">
              <h3 className="text-lg font-black text-gray-900 mb-2" data-id="element-1822">
                How accurate are the pace teams?
              </h3>
              <p className="text-gray-600" data-id="element-1823">
                Our certified pacers maintain splits within 5-10 seconds per
                mile. They're trained to account for course conditions, hills,
                and weather.
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1824">
              <h3 className="text-lg font-black text-gray-900 mb-2" data-id="element-1825">
                Can I switch pace teams during the race?
              </h3>
              <p className="text-gray-600" data-id="element-1826">
                Yes! If you're feeling strong, you can move up to a faster pace
                team. If you need to slow down, you can wait for the next pace
                team to catch up.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}